export const buildingConstants = {
	KIND_OFFICE: 'office',
	KIND_PARKING_LOT: 'parkinglot',
};
